<div class="flex-fill d-flex flex-column">
  <div class="btn-toolbar">
    @if (hasChanges()) {
      <button (click)="save()" class="btn btn-sm btn-primary me-2">Save</button>
    }
    @if (hasChanges()) {
      <button (click)="cancel()" class="btn btn-sm btn-success me-4">Cancel</button>
    }
    @if (!hasChanges()) {
      <button (click)="close()" class="btn btn-sm btn-primary me-4">Close</button>
    }
  </div>
  @if (product) {
    <div class="flex-fill p-3">
      <dx-form [formData]="product" [validationGroup]="'productValidationGroup'" [colCount]="2">
        <dxi-item itemType="group" caption="Product Information">
          <dxi-item dataField="partNumber">
            <dxi-validation-rule type="required" message="Part Number is required"></dxi-validation-rule>
            <dxi-validation-rule type="custom" message="Part Number must be unique" [validationCallback]="isUnique"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="description"></dxi-item>
          <dxi-item
            dataField="categoryId"
            [label]="{ text: 'Category' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: categories, displayExpr: 'name', valueExpr: 'id', onValueChanged: categoryChanged }"
            [isRequired]="true"
          ></dxi-item>
          <dxi-item
            dataField="mixStrengthId"
            [label]="{ text: 'Mix Strength' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: mixStrengths, displayExpr: 'name', valueExpr: 'id' }"
            [visible]="product.categoryId === ProductCategory.Types.RMix"
          ></dxi-item>
          <dxi-item
            dataField="locationId"
            [label]="{ text: 'Location' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: locations, displayExpr: 'name', valueExpr: 'id' }"
            [isRequired]="true"
          ></dxi-item>
          <dxi-item
            dataField="materialId"
            [label]="{ text: 'Material' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: materials, displayExpr: 'name', valueExpr: 'id' }"
            [isRequired]="true"
          ></dxi-item>
          @if(this.key !== 'new') {
            <dxi-item
              dataField="deliveryProductId"
              [label]="{ text: 'Delivery Product' }"
              editorType="dxSelectBox"
              [editorOptions]="{ items: deliveryProducts, displayExpr: 'partNumber', valueExpr: 'id' }"
            ></dxi-item>
          }
        </dxi-item>
        <dxi-item itemType="group" caption="Pricing and Measurement Information">
          <dxi-item dataField="cost" editorType="dxNumberBox" [isRequired]="true"></dxi-item>
          <dxi-item dataField="basePrice" editorType="dxNumberBox" [isRequired]="true"></dxi-item>
          <dxi-item dataField="shrinkPercentage" editorType="dxNumberBox"></dxi-item>
          <dxi-item
            dataField="inventoryUomId"
            [label]="{ text: 'Inventory UOM' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: uoms, displayExpr: 'name', valueExpr: 'id' }"
          ></dxi-item>
          <dxi-item
            dataField="priceUomId"
            [label]="{ text: 'Price UOM' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: uoms, displayExpr: 'name', valueExpr: 'id' }"
          ></dxi-item>
          <dxi-item [label]="{ text: 'Contractor Price' }">
            <div *dxTemplate>
              <dx-number-box [(value)]="contractorPrice" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
            </div>
          </dxi-item>
          <dxi-item [label]="{ text: 'Retail Price' }">
            <div *dxTemplate>
              <dx-number-box [(value)]="retailPrice" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
            </div>
          </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" caption="Notes">
          <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  }
</div>
